// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const V1_URL: any = '/teams/v1';
